import React, { useEffect } from "react";
import "../styles/General.css";

const DeliveryPopup = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  });
  if (!isOpen) return null;

  return (
    <>
      <div className="searchbar-overlay" onClick={onClose} />
      <div
        className="popup-content"
        style={{
          position: "fixed",
          top: "15%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          zIndex: 1001,
          width: "90%",
          maxWidth: "600px",
        }}
      >
        <div className="popup-header" style={{ marginBottom: "15px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ margin: 0 }}>Data livrării și ora livrării</h3>
            <button
              onClick={onClose}
              style={{
                border: "none",
                background: "none",
                fontSize: "25px",
                cursor: "pointer",

                position: "absolute",
                right: "8px",
                top: "0",
              }}
            >
              ×
            </button>
          </div>
          <hr
            style={{
              margin: "15px 0",
              border: "none",
              borderTop: "1px solid #eee",
            }}
          />
        </div>
        <div className="popup-body">
          <p style={{ margin: 0 }}>
            Te rugăm să alegi data și ora livrării înainte de a adăuga produsul
            în coș!
          </p>
        </div>
      </div>
    </>
  );
};

export default DeliveryPopup;
